export { default as CursorClickSolidIcon } from './CursorClickSolidIcon';
